module.exports = __webpack_public_path__ + "static/media/iceskates.49cfc150.png";